import { render, staticRenderFns } from "./IconHolder.vue?vue&type=template&id=7b94c4fd&scoped=true"
import script from "./IconHolder.vue?vue&type=script&lang=js"
export * from "./IconHolder.vue?vue&type=script&lang=js"
import style0 from "./IconHolder.vue?vue&type=style&index=0&id=7b94c4fd&prod&lang=scss"
import style1 from "./IconHolder.vue?vue&type=style&index=1&id=7b94c4fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../amenities/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b94c4fd",
  null
  
)

export default component.exports